import React from 'react';
import { useSubscription } from '../../context/SubscriptionContext';
import { AlertTriangle, Lock, Info, Zap } from 'lucide-react';
import { Button } from '../common';

export default function UpgradeBanner() {
  const { isPremium, getRecipeWarningLevel, usage, limits, promptUpgrade } = useSubscription();

  if (isPremium) return null;
  const level = getRecipeWarningLevel();
  if (!level) return null;

  const count = usage.recipeCount;
  const hardLimit = limits.recipes.hard;

  const styles = {
    hard: 'border-red-200 bg-red-50 dark:bg-red-900/20 dark:border-red-800 text-red-800 dark:text-red-300',
    grace: 'border-amber-200 bg-amber-50 dark:bg-amber-900/20 dark:border-amber-800 text-amber-800 dark:text-amber-300',
    soft: 'border-blue-200 bg-blue-50 dark:bg-blue-900/20 dark:border-blue-800 text-blue-800 dark:text-blue-300',
  };
  const Icon = level === 'hard' ? Lock : level === 'grace' ? AlertTriangle : Info;
  const title = level === 'hard'
    ? 'Recipe limit reached'
    : level === 'grace'
      ? 'Almost at the limit'
      : null;
  const subtitle = level === 'hard'
    ? `You have ${count}/${hardLimit} recipes. Upgrade to add more.`
    : `${count}/${hardLimit} ${level === 'grace' ? 'recipes used. Upgrade for unlimited.' : 'free recipes used.'}`;

  return (
    <div className={['flex items-center gap-3 p-3 rounded-lg border', styles[level]].join(' ')}>
      <Icon size={18} className="flex-shrink-0" aria-hidden="true" />
      <div className="flex-1 min-w-0 text-sm">
        {title && <div className="font-semibold">{title}</div>}
        <div className="text-xs">
          {subtitle}
          {level === 'soft' && (
            <button
              type="button"
              onClick={() => promptUpgrade('recipe_limit')}
              className="ml-1 underline font-medium"
            >
              Upgrade for unlimited
            </button>
          )}
        </div>
      </div>
      {level !== 'soft' && (
        <Button
          onClick={() => promptUpgrade('recipe_limit')}
          className="min-h-0 py-1.5 px-3 text-xs"
        >
          {level === 'hard' && <Zap size={14} aria-hidden="true" />}
          Upgrade
        </Button>
      )}
    </div>
  );
}
